/* eslint-disable import/no-unresolved */
/* eslint-disable @typescript-eslint/naming-convention */
import {
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  FormHelperText,
  Grid,
} from '@mui/material';
import { useField } from 'formik';

interface SelectInputProps {
  name: string;
  label: string;
  item: any[];
}

// THIS SELECT IS BUILT FOR A FORM

const SelectInput: React.FC<SelectInputProps> = ({ item, ...props }) => {
  const [field, meta] = useField(props);

  const isError = Boolean(meta.error && meta.touched);
  const isValid = Boolean(!meta.error && field.value);

  return (
    <Grid item xs={12}>
      <FormControl
        sx={{ width: '100%' }}
        error={isError}
        color={isValid ? 'success' : 'primary'}
      >
        <InputLabel id="demo-simple-select-readonly-label">
          {props.label}
        </InputLabel>

        <Select
          name={props.name}
          value={field.value}
          label={props.label}
          onChange={field.onChange}
          onBlur={field.onBlur}
        >
          {item?.map((value: any) => (
            <MenuItem key={value.name} value={value.name}>
              {value.name}
            </MenuItem>
          ))}
        </Select>
        {isError && <FormHelperText>{meta.error}</FormHelperText>}
      </FormControl>
    </Grid>
  );
};

export default SelectInput;
